import { useEffect } from 'react';
import getValidParams from './getValidParams';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';

export const useRawOrigin = ({ urlQueryParams, history }) => {
    useEffect(() => {
        const validParams = getValidParams(urlQueryParams);
        const { bounds, origin } = validParams;
        /**
         * if there are no bounds neither origin, it is a map search case,
         * and raw origin query string has to be converted into bounds;
         *
         * the opposite scenario is carried out by createSearchAgentGroup function
         * when a new search group is created
         */
        if (!bounds && !origin) {
            const rawUrlSearchParams = new URLSearchParams(window.location.search);
            const { origin: rawOrigin } = Object.fromEntries(rawUrlSearchParams.entries());

            const routes = routeConfiguration();
            const routeName = 'SearchPage';

            if (rawOrigin) {
                const validURI = createResourceLocatorString(
                    routeName,
                    routes,
                    {},
                    { ...validParams, bounds: rawOrigin }
                );
                history.replace(validURI);
            }
        }
    }, []);
};
